"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var nanoid_1 = __importDefault(require("nanoid"));
var _1 = require("../util/_");
var Checkbox = /** @class */function (_super) {
  __extends(Checkbox, _super);
  function Checkbox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      checked: typeof _this.props.checked !== 'undefined' ? _this.props.checked : _this.props.defaultChecked,
      indeterminate: _this.props.indeterminate || false
    };
    _this.isChecked = function () {
      return typeof _this.props.checked !== 'undefined' ? _this.props.checked : _this.state.checked;
    };
    _this.isIndeterminate = function () {
      return typeof _this.props.indeterminate !== 'undefined' ? _this.props.indeterminate : _this.state.indeterminate;
    };
    _this.handleChange = function (e) {
      var value = e.target.checked;
      if (_this.props.disabled) {
        return;
      }
      if (typeof _this.props.checked === 'undefined') {
        _this.setState({
          checked: value
        }, function () {
          if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
          }
        });
      } else {
        if (typeof _this.props.onChange === 'function') {
          _this.props.onChange(value);
        }
      }
    };
    return _this;
  }
  Checkbox.prototype.componentWillReceiveProps = function (nextProps) {
    if (typeof nextProps.checked !== 'undefined' && nextProps.checked !== this.state.checked) {
      this.setState({
        checked: nextProps.checked
      });
    }
    if (typeof nextProps.indeterminate !== 'undefined' && nextProps.indeterminate !== this.state.indeterminate) {
      this.setState({
        indeterminate: nextProps.indeterminate
      });
    }
  };
  Checkbox.prototype.render = function () {
    var _a;
    var _b = this.props,
      className = _b.className,
      tabIndex = _b.tabIndex,
      children = _b.children,
      disabled = _b.disabled,
      name = _b.name,
      inline = _b.inline,
      autoFocus = _b.autoFocus,
      isToDo = _b.isToDo;
    var inputId = 'checkbox_' + nanoid_1.default();
    var checked = this.isChecked();
    var indeterminate = this.isIndeterminate();
    var customProps = _1.omit(this.props, Object.keys(Checkbox.propTypes));
    var checkboxClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('checkbox')] = true, _a[vdl_prefix_1.vdlPrefix('input--inline')] = inline, _a);
    return react_1.default.createElement("div", __assign({
      className: classnames_1.classNames(className, checkboxClasses)
    }, customProps), react_1.default.createElement("input", {
      id: inputId,
      type: "checkbox",
      autoFocus: autoFocus,
      tabIndex: disabled ? -1 : tabIndex || 0,
      onChange: this.handleChange,
      checked: checked,
      name: name,
      "aria-disabled": disabled,
      disabled: disabled,
      ref: function ref(el) {
        return el && (el.indeterminate = indeterminate);
      }
    }), react_1.default.createElement("label", {
      htmlFor: inputId,
      className: isToDo && checked && !indeterminate ? vdl_prefix_1.vdlPrefix('is-done') : ''
    }, children));
  };
  Checkbox.propTypes = {
    autoFocus: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    required: prop_types_1.default.bool,
    onChange: prop_types_1.default.func,
    checked: prop_types_1.default.bool,
    defaultChecked: prop_types_1.default.bool,
    name: prop_types_1.default.string,
    className: prop_types_1.default.string,
    tabIndex: prop_types_1.default.number,
    children: prop_types_1.default.node,
    inline: prop_types_1.default.bool,
    indeterminate: prop_types_1.default.bool,
    parent: prop_types_1.default.object,
    isToDo: prop_types_1.default.bool
  };
  Checkbox.defaultProps = {
    autoFocus: false,
    disabled: false,
    required: false,
    defaultChecked: false,
    inline: false,
    indeterminate: false,
    isToDo: false
  };
  return Checkbox;
}(react_1.default.PureComponent);
exports.Checkbox = Checkbox;